import React, { FC, PropsWithChildren } from "react";
import cn from "classnames";
import stl from "./Top.desktop.module.scss";
import Socials from "./Socials";
import Links from "./Links";
import Languages from "./Languages";
import { useStore } from "effector-react";
import { SettingsEndpoint } from "../../store/endpoints";
import { Button } from "../../components";
import { useTranslation } from "react-i18next";
import { AppConfig } from "../../config";
import Logo from "./Logo";
import ImportantAnnouncement from "./ImportantAnnouncement";

const TopDesktop: FC<{
  className?: PropsWithChildren<HTMLDivElement>["className"];
}> = ({ className }) => {
  const { t } = useTranslation(AppConfig.translationFileNames.base);
  const { data: settings } = useStore(SettingsEndpoint.store);

  return (
    <>
      <div className={cn(className, stl.block)}>
        <div className={stl.inner}>
          <div className={stl.left}>
            <Socials />
            <Links />
          </div>
          <div className={stl.center}>
            <Logo imgClass={stl.center__logo} />
          </div>
          <div className={stl.right}>
            <Languages />
            {settings?.contact_url && (
              <div>
                <Button
                  href={settings.contact_url}
                  target={"_blank"}
                  rel={"noreferrer"}
                  variant={"callToAction"}
                >
                  {t("contact")}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
      <ImportantAnnouncement />
    </>
  );
};

export default TopDesktop;
